import { queryClient } from '../queryClient'
import { asyncPersister } from './persister'

const LAST_USER_KEY = 'eclipse_last_user'

// Note: every cached row is only what the user who fetched it was allowed to see, and signing out in
// the app never reloads the page, so a different user signing in on the same device would otherwise
// inherit the previous user's rows until a hard refresh.
export async function resetCachedQueriesIfUserChanged(email: string): Promise<void> {
  const user = email.trim().toLowerCase()
  const previousUser = localStorage.getItem(LAST_USER_KEY)

  localStorage.setItem(LAST_USER_KEY, user)

  if (previousUser === null || previousUser === user) return

  queryClient.clear()
  await asyncPersister.removeClient()
}
